import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getToken } from '@/utils/auth'; // getToken from cookie

export default {
  data: function data() {
    return {
      importHeaders: {
        'access-token': getToken()
      },
      fileList: [],
      addPicUrlList: [],
      deletePicUrl: [],
      uploadUrl: '',
      picUrl: '',
      dialogPreVisible: false,
      childData: {
        pictureList: null
      },
      addList: [],
      oldImgList: [],
      removeList: [],
      listObj: {},
      isBtnDisable: false
    };
  },
  props: ['keyValue', 'showDialog'],
  created: function created() {
    this.init();
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs['dataForm'].resetFields();

        if (this.showDialog) {
          this.init();
        }
      }
    }
  },
  methods: {
    init: function init() {
      this.isBtnDisable = false;
      this.uploadUrl = process.env.BASE_API + '/stpt-device/api/multi/upload';
      if (this.keyValue) this.fileList = this.keyValue.slice(0);else this.fileList = [];
      this.addList = [];
      this.oldImgList = [];
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: '最多只能上传3个图片!',
        type: 'warning'
      });
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.addList.push({
        url: response.data.fileName
      });
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);

      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].name === uid) {
          this.listObj[objKeyArr[i]].url = response.data.fileName;
        }
      }

      this.fileList.push({
        url: response.data.fileName
      });
      this.fileList.forEach(function (item, index) {
        item.imgSort = index + 1;
      }); // this.fileList = Object.keys(this.listObj).map(
      //   (item) => this.listObj[item]
      // )
    },
    beforeUpload: function beforeUpload(file) {
      var _this = this;

      var fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise(function (resolve, reject) {
        _this.listObj[fileName] = {
          name: file.uid
        };
        resolve(true);
      });
    },
    handleRemove: function handleRemove(file) {
      var _this2 = this;

      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);

      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
        }
      }

      this.oldImgList.forEach(function (item) {
        if (item.url === file.url) {
          var startIndex = item.url.indexOf('/ibms');
          var imgUrl = item.url.split('').splice(startIndex).join('');

          _this2.removeList.push({
            url: imgUrl
          });
        }
      });
      this.fileList.forEach(function (item, index) {
        if (item.url === file.url) {
          _this2.fileList.splice(index, 1);
        }
      });
      this.addList.forEach(function (item, index) {
        if (item.url === file.url) {
          _this2.addList.splice(index, 1);
        }
      });
      this.fileList.forEach(function (item, index) {
        item.imgSort = index + 1;
      });
    },
    handlePreview: function handlePreview(file) {
      this.picUrl = file.url;
      this.dialogPreVisible = true;
    },
    loadData: function loadData() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    compare: function compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    handCreate: function handCreate() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this4.fileList.length > 0) {
            _this4.childData.pictureList = _this4.fileList.map(function (item) {
              var picUrl = {};
              var startIndex = item.url.indexOf('/ibms');
              picUrl.fileaddress = item.url.split('').splice(startIndex).join('');
              picUrl.url = item.url.split('').splice(startIndex).join('');
              picUrl.imgSort = item.imgSort;
              return picUrl;
            });
          }

          if (_this4.childData.pictureList.length > 0) {
            _this4.childData.pictureList.sort(_this4.compare('imgSort'));
          }

          console.log('zzz', _this4.childData.pictureList);

          _this4.$emit('handCancle', true, _this4.childData.pictureList);

          _this4.isBtnDisable = true;
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};